import {extend,joinUrl,joinIfAbsent,insertStylesheetLink,addStylesMapper,
    setCustomTextProps,setCurrentLocale,resetLocales} from 'pexui';
import * as utils from '../utilities/utils';
import defaultTheme from './default';
import dxpDumasTheme from './dxp_dumas';
import dxpAcqTheme from './dxp_acq';
import intlEapplyTheme from './intl_eapply';

const Promise = utils.Promise;

const hostedLocales = {
    // Supports old convention for setting locale
    'US': 'en_US',
    'en': 'en_US',
    'es': 'es_US',
    'fr': 'fr_CA',
    'IN': 'en_IN',
    'jp': 'jp_JP',
    'JP': 'jp_JP',
    // Supports new convention
    'en_UK': 'en_UK',
    'en_US': 'en_US',
    'es_US': 'es_US',
    'fr_CA': 'fr_CA',
    'en_IN': 'en_IN',
    'jp_JP': 'jp_JP',
    'zh_CN': 'zh_CN',
};

let customTheme = null;

function setTheme(theme){
    addStylesMapper(theme);

    customTheme = theme;
}

function decideThemes(widgetConfig, widgetRequest){
    const originatorId = widgetRequest.originator_id;

    // do with default
    addStylesMapper(defaultTheme);

    // --------- theme rules ------------
    switch(originatorId.toUpperCase()){
        case 'DXP_DUMAS':
            setTheme(dxpDumasTheme);
            break;
        case 'DXP_ACQUISITION':
            setTheme(dxpAcqTheme);
            break;
        case 'INTL_EAPPLY':
            setTheme(intlEapplyTheme);
            break;
    }

    // ----------------------------------
}

// initTheme
module.exports = function (widgetConfig, widgetRequest){
    decideThemes(widgetConfig, widgetRequest);

    if(widgetConfig.invoker_style_url && (typeof widgetConfig.invoker_style_url === 'object'
        || typeof widgetConfig.invoker_style_url === 'function')){
        addStylesMapper(widgetConfig.invoker_style_url);
        widgetConfig.invoker_style_url = null; // clean the parameter in order to pass the server-side validation.
    }

    var urlCss = (widgetConfig.invoker_style_url && typeof widgetConfig.invoker_style_url === 'string')?
        widgetConfig.invoker_style_url :
        ( widgetConfig.invoker_style_url === true? 'none' :
            joinUrl(joinIfAbsent(utils.getBaseUri(), 'infowidget'),'styles/dls-widget.min.css')
        );

    if(urlCss && urlCss !== 'true' && urlCss !== 'none' && urlCss !== 'provided'){
        insertStylesheetLink(urlCss);
    }
    
    //
    if(urlCss && urlCss !== 'true' && urlCss !== 'none'){
        insertStylesheetLink(joinUrl(joinIfAbsent(utils.getBaseUri(), 'infowidget'),'styles/pex_getinfo_widget.css'));
    }

    // do with textual props
    resetLocales();
   
    let locale = 'default';
    const invokerLocale = widgetConfig.invoker_locale;

    if (invokerLocale && hostedLocales[invokerLocale]) {
        locale = invokerLocale;
    }

    let internalJsonMandatory = true;
    if(widgetConfig.invoker_prop_url){
        setCustomTextProps(widgetConfig.invoker_prop_url);

        if(typeof widgetConfig.invoker_prop_url === 'object'
            || typeof widgetConfig.invoker_prop_url === 'function'){
            widgetConfig.invoker_prop_url = null; // clean the parameter in order to pass the server-side validation.
        }
        // once the invoker provides a customized resource, the internal one is not mandatory.
        internalJsonMandatory = false;
    }else if( customTheme && customTheme.labels && customTheme.labels[locale]){
        setCustomTextProps(customTheme.labels[locale]);
    }
    const resourceUrl = joinUrl(joinIfAbsent(utils.getBaseUri(), 'infowidget'), 'locales/json/' + locale + '.json?' + Date.now());
    return new Promise(function(resolve, reject) {
        setCurrentLocale(resourceUrl,
            () => { resolve() },
            (error) => {
                reject(Error('Failed to download default content from Url: ' + resourceUrl + ', error: ' + error));
        });
    });
};



// WEBPACK FOOTER //
// ./application/src/themes/index.js